import { Text, Button } from "@findemdev/maui";
import styled from "styled-components";

export const ExtPromotor = styled.div`
  position: relative;
  display: flex;
  width: 198px;
  flex-direction: column;
  flex-shrink: 0;
  align-items: flex-start;
  box-sizing: border-box;
  border-radius: 9px;
  border: 1px solid ${({ theme }) => theme.colors['grey-300']};
  background: ${({ theme }) => theme.colors['white']};
  overflow: hidden;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 2px;
  top: 2px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.dimensions.spacing[3]};
  height: ${({ theme }) => theme.dimensions.spacing[3]};
  padding: 0;
  border: none;
  border-radius: ${({ theme }) => theme.dimensions.spacing[3]};
  background: transparent;
  color: ${({ theme }) => theme.colors['grey-500']};
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.72);
  }
`;

export const ExtArtWrapper = styled.div<{ backgroundImage?: string }>`
  height: 102px;
  align-self: stretch;
  background: ${({ backgroundImage, theme }) => backgroundImage
    ? `url(${backgroundImage}) center/cover no-repeat, linear-gradient(0deg, rgba(69, 153, 250, 0.05) 0%, rgba(69, 153, 250, 0.05) 100%), ${theme.colors['blue-100']}`
    : `linear-gradient(0deg, rgba(69, 153, 250, 0.05) 0%, rgba(69, 153, 250, 0.05) 100%), ${theme.colors['blue-100']}`
  };
  border-top-left-radius: ${({ theme }) => theme.dimensions['border-radius'].md};
  border-top-right-radius: ${({ theme }) => theme.dimensions['border-radius'].md};
  overflow: hidden;
`;

export const SecondArt = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.dimensions.spacing[2]};
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions.spacing[2]};
  align-self: stretch;
`;

export const SecondArtTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.dimensions.spacing[1]};
  align-self: stretch;
`;

export const TitleText = styled(Text)`
  overflow: hidden;
  color: ${({ theme }) => theme.colors['grey-700']};
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
`;

export const BelowText = styled(Text)`
  color: ${({ theme }) => theme.colors['grey-600']};
  font-size: 12px;
`;

export const LearnMoreLink = styled(Text)`
  color: ${({ theme }) => theme.colors['blue-400']};
  font-size: 12px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const InstallButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions.spacing[1]};
`;
